import { BasePagination, BasePaginationRespone } from '../../base/BasePaginationRespone';
import { BaseSelectRequest } from '../../base/BaseSelectRequest';
import { BaseShowDetail } from '../../base/BaseShowDetail';
import { BaseAction } from '../../base/IBaseActionRespone';
import { CollectionItemModel } from '../../models/collections/CollectionItemModel';
import { CollectionItemRequest } from '../../models/collections/CollectionItemRequest';
import { CollectionItemResponse } from '../../models/collections/CollectionItemResponse';
import { KeywordSeoModel } from '../../models/crm/KeywordSeoModel';
import {
	CollectionItemAction_CHANGE_SELECTED_IDS,
	CollectionItemAction_DELETE_Failure,
	CollectionItemAction_DELETE_Request,
	CollectionItemAction_DELETE_Success,
	CollectionItemAction_GETALL_Failure,
	CollectionItemAction_GETALL_Request,
	CollectionItemAction_GETALL_Success,
	CollectionItemAction_GETPAGINATION_Failure,
	CollectionItemAction_GETPAGINATION_Request,
	CollectionItemAction_GETPAGINATION_Success,
	CollectionItemAction_RELOAD,
	CollectionItemAction_SAVE_Failure,
	CollectionItemAction_SAVE_Request,
	CollectionItemAction_SAVE_Success,
	CollectionItemAction_SHOW_CONFIRM,
	CollectionItemAction_SHOW_DETAIL,
	eCollectionItemActionTypeIds,
} from './ICollectionItemActionsTypes';

export const CollectionItemActions = {
	//ALL
	getAllRequest: (data: CollectionItemRequest): CollectionItemAction_GETALL_Request =>
		BaseAction(eCollectionItemActionTypeIds.GET_ALL_REQUEST, data),
	getAllSuccess: (data: CollectionItemResponse[]): CollectionItemAction_GETALL_Success =>
		BaseAction(eCollectionItemActionTypeIds.GET_ALL_SUCCESS, data),
	getAllFailure: (error: Error | string): CollectionItemAction_GETALL_Failure =>
		BaseAction(eCollectionItemActionTypeIds.GET_ALL_FAILURE, error),
	//LIST
	getPaginationRequest: (request: BaseSelectRequest): CollectionItemAction_GETPAGINATION_Request =>
		BaseAction(eCollectionItemActionTypeIds.GET_PAGINATION_REQUEST, request),
	getPaginationSuccess: (data: BasePaginationRespone<CollectionItemModel>): CollectionItemAction_GETPAGINATION_Success =>
		BaseAction(eCollectionItemActionTypeIds.GET_PAGINATION_SUCCESS, data),
	getPaginationFailure: (error: Error | string): CollectionItemAction_GETPAGINATION_Failure =>
		BaseAction(eCollectionItemActionTypeIds.GET_PAGINATION_FAILURE, error),
	//SAVE
	saveRequest: (entity: CollectionItemModel): CollectionItemAction_SAVE_Request =>
		BaseAction(eCollectionItemActionTypeIds.SAVE_REQUEST, entity),
	saveSuccess: (message: string): CollectionItemAction_SAVE_Success => BaseAction(eCollectionItemActionTypeIds.SAVE_SUCCESS, message),
	saveFailure: (error: Error | string): CollectionItemAction_SAVE_Failure => BaseAction(eCollectionItemActionTypeIds.SAVE_FAILURE, error),
	//DELETE
	deleteRequest: (ids: number[]): CollectionItemAction_DELETE_Request => BaseAction(eCollectionItemActionTypeIds.DELETE_REQUEST, ids),
	deleteSuccess: (message: string): CollectionItemAction_DELETE_Success => BaseAction(eCollectionItemActionTypeIds.DELETE_SUCCESS, message),
	deleteFailure: (error: Error | string): CollectionItemAction_DELETE_Failure =>
		BaseAction(eCollectionItemActionTypeIds.DELETE_FAILURE, error),
	//RELOAD
	needReload: (): CollectionItemAction_RELOAD => BaseAction(eCollectionItemActionTypeIds.NEED_RELOAD, undefined),
	//ACTIONs
	changeSelectedIds: (ids: number[]): CollectionItemAction_CHANGE_SELECTED_IDS =>
		BaseAction(eCollectionItemActionTypeIds.CHANGE_SELECTED_IDS, ids),
	showDetail: (detail: BaseShowDetail<CollectionItemModel>): CollectionItemAction_SHOW_DETAIL =>
		BaseAction(eCollectionItemActionTypeIds.SHOW_DETAIL, detail),
	showConfirm: (show: boolean): CollectionItemAction_SHOW_CONFIRM => BaseAction(eCollectionItemActionTypeIds.SHOW_CONFIRM, show),
};
